module.exports = __webpack_public_path__ + "img/file-uploader.b61dfc45.svg";